import { ThemeOptions } from '@mui/material';
import type {} from '@mui/material/Typography';

declare module '@mui/material/Typography' {
  // tslint:disable-next-line:interface-name
  interface TypographyPropsVariantOverrides {
    d1: true;
    d2: true;
    d3: true;
    d4: true;
    d5: true;
    d6: true;
    bodyXLarge: true;
    bodyLarge: true;
    bodyDefault: true;
    bodySmall: true;
    bodyXSmall: true;
    arrow: true;
  }
}

export const MuiTypography: ThemeOptions['components']['MuiTypography'] = {
  defaultProps: {
    variant: 'bodyDefault',
    variantMapping: {
      d1: 'div',
      d2: 'div',
      d3: 'div',
      d4: 'div',
      d5: 'div',
      d6: 'div',
      bodyXLarge: 'p',
      bodyLarge: 'p',
      bodyDefault: 'p',
      bodySmall: 'p',
      bodyXSmall: 'p',
      arrow: 'div'
    }
  },
  variants: [
    {
      props: { variant: 'arrow' },
      style: {
        '&:after': {
          content: '"\\00a0»"'
        }
      }
    }
  ]
};
